import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://api.integrasolve.dev.ditmac.com',
  cognitoPoolId: 'us-east-1_nIbGbydJX',
  cognitoClientId: 'brrkjgqbm0ikofg2sbvj5c2fr'
};
